export const IconResumeCv20: {
  name: 'icon_resume_cv_20-4a928325e2d0'
} = {
  name: 'icon_resume_cv_20-4a928325e2d0'
}
